export const capitalizeFirstLetter = (input?: string) => {
    return input ? input.charAt(0).toUpperCase() + input.slice(1) : ""
}
